import { LabelsInterface } from "../../InterfaceModels/LabelsInterface";

export const labels: LabelsInterface[] = [
  {
    name: "New Project",
    class: "project",
    data: "project",
  },
  {
    name: "Client Request",
    class: "client-request",
    data: "client-request",
  },
  {
    name: "Urgent",
    class: "urgent",
    data: "urgent",
  },
  {
    name: "Satisfaction",
    class: "satisfaction",
    data: "satisfaction",
  },
];
